<script setup>
    defineProps({
        customer: {
            type: Object
        },
        darkmode: {
            type: Boolean,
            default: false
        }
    });

    const emit = defineEmits(['edit']);

    const editCustomer = (data) => {

        emit('edit', data);

    }
</script>

<template>
    <div :id="'customer'+ customer.id" class="col-12 border-bottom">
        <div class="row align-items-center row-transactions">
            <div class="col-9 col-sm-10" @click="editCustomer(customer)" data-bs-toggle="modal" data-bs-target="#addCustomer">
                <div class="row align-items-center">
                    <div 
                        class="col-12 col-sm-6 cursor-pointer" 
                        v-tooltip="{
                            content:'Ver detalhes',
                            distance: 15
                        }">
                        <h6 class="mb-0 text-md transaction-description">{{ customer.name }}</h6>
                    </div>
                </div>
            </div>
            <div class="col-3 col-sm-2 text-end"></div>
        </div>
    </div>
</template>